// import styles from './home.module.css'

export function Joblinks({ head }) {
  return (
    <>
      <div>
        <div>
          <h2>{head}</h2>
        </div>
        <div>
          <ul>
            <li>
              <a href="#a">Accounting Jobs</a>
            </li>
            <li>
              <a href="#a">Analytics Jobs</a>
            </li>
            <li>
              <a href="#a">Animation Jobs</a>
            </li>
            <li>
              <a href="#a">Architecture Jobs</a>
            </li>
            <li>
              <a href="#a">Banking Jobs</a>
            </li>
            <li>
              <a href="#a">BPO Jobs</a>
            </li>
            <li>
              <a href="#a">Java Jobs</a>
            </li>
            <li>
              <a href="#a">Networking Jobs</a>
            </li>
            <li>
              <a href="#a">Teaching Jobs</a>
            </li>
            <li>
              <a href="#a">Banking Jobs</a>
            </li>
            <li>
              <a href="#a">BPO Jobs</a>
            </li>
            <li>
              <a href="#a">Java Jobs</a>
            </li>
            <li>
              <a href="#a">Networking Jobs</a>
            </li>
            <li>
              <a href="#a">Teaching Jobs</a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}
